import { PROVINCES, STREET_TYPES } from 'financing/constants/localization.js';
import { FINANCING_FREQUENCIES } from 'financing/constants/employment.js';

const workInputs = [
    {
        inputName: 'employer',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYER',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.EMPLOYER',
        inputType: 'text',
        isRequired: true,
        classNames: 'half',
    },
    {
        inputName: 'occupation',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.OCCUPATION',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.OCCUPATION',
        inputType: 'text',
        isRequired: true,
        classNames: 'half',
    },
    {
        inputName: 'yearsAtEmployment',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.YEARS_AT_EMPLOYMENT',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.YEARS_AT_EMPLOYMENT',
        inputType: 'number',
        isRequired: true,
        classNames: 'half',
    },
    {
        inputName: 'monthsAtEmployment',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.MONTHS_AT_EMPLOYMENT',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.MONTHS_AT_EMPLOYMENT',
        inputType: 'number',
        isRequired: true,
        classNames: 'half',
    },
    {
        inputType: 'subhead',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.EMPLOYER_ADDRESS', // TODO: # fix unknown key
    },
];

const employerAddressInputs = [
    {
        inputName: 'streetNumber',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_NUMBER',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.STREET_NUMBER',
        inputType: 'text',
        isRequired: false,
        classNames: 'third',
    },
    {
        inputName: 'streetName',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_NAME',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.STREET_NAME',
        inputType: 'text',
        isRequired: true,
        classNames: 'third',
    },
    {
        inputName: 'streetType',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.STREET_TYPE',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.STREET_TYPE',
        inputType: 'dropdown',
        isRequired: true,
        classNames: 'third',
        options: STREET_TYPES,
    },
    {
        inputName: 'unitNumber',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.UNIT_NUMBER',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.UNIT_NUMBER',
        inputType: 'text',
        isRequired: false,
        classNames: 'full',
    },
    {
        inputName: 'postalCode',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.POSTAL_CODE',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.POSTAL_CODE',
        inputType: 'postalCode',
        isRequired: true,
        classNames: 'third',
    },
    {
        inputName: 'city',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.CITY',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.CITY',
        inputType: 'text',
        isRequired: true,
        classNames: 'third',
    },
    {
        inputName: 'province',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.PROVINCE',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.PROVINCE',
        inputType: 'dropdown',
        isRequired: true,
        classNames: 'third',
        options: PROVINCES,
    },
    {
        inputName: 'phoneNumber',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.PHONE_NUMBER',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.PHONE_NUMBER',
        inputType: 'phone',
        isRequired: true,
        classNames: 'double-third',
    },
    {
        inputName: 'phoneExtension',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.PHONE_EXTENSION',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.PHONE_EXTENSION',
        inputType: 'tel',
        isRequired: false,
        classNames: 'third',
    },
];

const incomeInputs = [
    {
        inputName: 'incomes',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOMES',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.INCOMES',
        inputType: 'dropdown',
        isRequired: true,
        classNames: 'half',
        options: FINANCING_FREQUENCIES,
    },
    {
        inputName: 'incomeGross',
        transKey: 'FINANCING.EMPLOYMENT_INFOS.INCOME_GROSS',
        errorTransKey: 'COMMONS_FORMS.ERRORS.EMPLOYMENT_INFOS.INCOME_GROSS',
        inputType: 'number',
        isRequired: true,
        classNames: 'half',
    },
];

const employedInputs = [...workInputs, ...employerAddressInputs, ...incomeInputs];

const employmentInfosConfig = {
    employed: employedInputs,
    selfEmployed: employedInputs,
    retired: incomeInputs,
    unemployed: [],
    student: [],
    other: [],
};

export default employmentInfosConfig;
